import catalog from './messages.json';
const lookup=new Map();
const normalize=text=>text.trim().replace(/\s+/g,' ');
for(const row of catalog){
  for(const text of [row.source,row.en,row.zh])if(text&&(!lookup.get(normalize(text))?.reviewed||row.reviewed))lookup.set(normalize(text),row);
}
const chinese=/[\u3400-\u9fff]/;
const escape=value=>value.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
const fragments=[...lookup.keys()].filter(text=>chinese.test(text)&&!text.includes('<')).sort((a,b)=>b.length-a.length);
const matcher=fragments.length?new RegExp(fragments.map(escape).join('|'),'g'):null;
// Specific sentences must win over broad patterns such as "{0} hand {1}".
const templates=catalog.filter(row=>row.source.includes('{0}'))
  .sort((a,b)=>b.source.replace(/\{\d+\}/g,'').length-a.source.replace(/\{\d+\}/g,'').length)
  .map(row=>({row,pattern:new RegExp('^'+escape(row.source).replace(/\\\{(\d+)\\\}/g,'(.*?)')+'$')}));
export function translateText(value,language='en'){
  if(typeof value!=='string'||!value.trim())return value;
  const text=normalize(value),row=lookup.get(text);
  if(row){const translated=row[language]||row.en||text;return normalize(translated)===text?value:value.replace(value.trim(),translated);}
  for(const {row,pattern} of templates){const match=text.match(pattern);if(match)return (row[language]||row.en||text).replace(/\{(\d+)\}/g,(_,index)=>translateText(match[Number(index)+1],language));}
  if(language==='zh'||!chinese.test(text)||!matcher)return value;
  // Dynamic counts and material names reuse known phrases. Unrecognized merchant
  // copy stays visible rather than being silently removed or sent to a third party.
  return value.replace(matcher,source=>{const row=lookup.get(source);return ' '+(row[language]||row.en||source)+' ';}).replace(/ {2,}/g,' ').trim();
}
export function translatedSearch(values,query,language='en'){
  const fold=value=>String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const haystack=values.filter(Boolean).flatMap(value=>[value,translateText(value,language)]).join(' ');
  return fold(haystack).includes(fold(query.trim()));
}
